<template>
  <transition name="overlay">
    <div class="overlay" @click.self="hide">
      <slot />
    </div>
  </transition>
</template>

<script>
import {
  clearAllBodyScrollLocks,
  disableBodyScroll,
  enableBodyScroll
} from 'body-scroll-lock'

export default {
  name: 'OverlayComponent',
  emits: ['show', 'hide'],
  data() {
    return {
      visible: false
    }
  },
  unmounted() {
    clearAllBodyScrollLocks()
  },
  methods: {
    show() {
      this.visible = true
      disableBodyScroll(this.$refs.content)
      this.$emit('show')
    },
    hide() {
      this.visible = false
      enableBodyScroll(this.$refs.content)
      this.$emit('hide')
    }
  }
}
</script>

<style lang="scss">
.overlay {
  align-items: center;
  background-color: rgba(#000, 0.2);
  display: flex;
  justify-content: center;
  position: fixed;
  overflow: hidden;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  z-index: 999;
  transition: opacity 0.5s ease;
}

.overlay-enter-from {
  opacity: 0;
}

.overlay-leave-active {
  opacity: 0;
}

.overlay-enter-from .overlay__content,
.overlay-leave-active .overlay__content {
  transform: translateY(200px);
}
</style>
